module.exports = __webpack_public_path__ + "img/aboutus02.e1c4928a.png";